export default ({ request }) => ({

  listResearchInfoImageApi(data) {
    return request({
      url: '/digitalCenter/researchInfoImage/list',
      method: 'post',
      data
    })
  },
  saveResearchInfoImageApi(data) {
    return request({
      url: '/digitalCenter/researchInfoImage/save',
      method: 'post',
      data
    })
  },
  delResearchInfoImageApi(data) {
    return request({
      url: '/digitalCenter/researchInfoImage/del',
      method: 'post',
      data
    })
  },
})
